export default "__VITE_ASSET__BmeZnO_e__"